export default {
  'accountSettings.title': '账号',

  'accountSettings.field.restaurantName': '餐厅名',
  'accountSettings.field.ownerName': '餐厅所有者',
  'accountSettings.field.restaurantAddress': '餐厅地址',
  'accountSettings.field.restaurantWifiPassword': '密码',
  'accountSettings.field.restaurantWifi': '网络名:',
  'accountSettings.field.email': '注册邮箱',
  'accountSettings.field.password': '登录密码',
  'accountSettings.field.settlementTime': '结算时间',
  'accountSettings.field.bankAccountLink': '银行账户',
  'accountSettings.field.payoutAccountLink': '打款账户链接',
  'accountSettings.field.payoutAccountLink.tooltip':
    '请用此链接来注册Stripe打款账户。我们会把刷卡的交易额，打款给此账户绑定的银行账户。',
  'accountSettings.field.adyenOnboard': '设置账户',
  'accountSettings.field.adyenOnboard.tooltip': '请使用此链接添加 Adyen 帐户。',
  'accountSettings.field.invoicingAccountLink': '扣费账户链接',
  'accountSettings.field.invoicingAccountLink.tooltip':
    '您可以用此链接来注册Stripe扣费账户。我们会从您的扣费账户扣除刷卡手续费。您可以绑定和打款一样或者不同的银行账户。',
  'accountSettings.account.blank': '点此设置账号',
  'accountSettings.editWifiInfo': '修改Wi-Fi设置',
  'accountSettings.field.closeoutReportCutoffTime': '报告截止时间',
  'accountSettings.field.closeoutReportCutoffTime.tooltip':
    '所有报告均基于24小时时间段计算。举例说明，如果截止时间设置为2:00:00 am，则1/1/2023当天的报告将包含从 1/1/2023 2:00:00 am 到 1/2/2023 1:59:59 am 的数据。',
  'accountSettings.time': '时间',
  'accountSettings.startOfTheWeek': '一周的第一天',
  'accountSettings.bindPayoutAccount': '绑定打款账号',
  'accountSettings.bindInvoiceAccount': '绑定收款账号',
  'accountSettings.field.adyen.payoutAccountLink': '打款账户',
  'accountSettings.field.adyen.payoutAccountLink.tooltip': '我们会把刷卡的交易额，打款给此银行账户。',
  'accountSettings.field.adyen.invoicingAccountLink': '扣费账户',
  'accountSettings.field.adyen.invoicingAccountLink.tooltip':
    '我们会从此银行账户扣除您的刷卡手续费。您可以绑定和打款一样或者不同的银行账户。',
  'accountSettings.field.adyen.bind.failed': '绑定账户失败',
  'accountSettings.field.adyen.bindButton.change': '换卡',
  'accountSettings.field.adyen.bindButton.bind': '绑卡',
  'accountSettings.information.adyen.missing': '缺失一些必要信息，请联系您的管理员.',
  'accountSettings.information.adyen.server_error': '服务异常，请联系您的管理员.',
  'accountSettings.serviceTime': '服务时段',
  'accountSettings.set.serviceTime': ' <a>这里</a> 设置您的服务时段更方便的按照就餐时段统计营业数据',
  'accountSettings.set.serviceTime.tip': '您修改了报告截止时间或一周的第一天，请重新检查并保存您的服务时段设置。',
  'accountSettings.set.serviceTime.cancel': '暂不',
  'accountSettings.set.serviceTime.confirm': '去设置',

  'accountSettings.field.newPaymentCutoff': '报告截止时间不能晚于 {lastTime}',
  'accountSettings.field.newPaymentCutoff.des':
    '您的cut off时间，至少比我们的Batch Settlement Time要早一个小时，来方便您给订单增加或调整小费',
  'accountSettings.field.batchSettlementTime': '批量结算时间：{time}',
  'accountSettings.field.batchSettlementTime.des':
    '批量结算时间，是指每个营业日结束时，将所有交易汇总并发送给支付处理器进行最终处理，确保准确的支付结算',

  'accountSettings.set.modifications': '编辑',
  'accountSettings.set.modificationsLog': '修改记录',
  'accountSettings.set.step1.des1': '报告截止时间直接影响销售报表和员工报表的数据，请慎重修改！',
  'accountSettings.set.step1.des2': '如需修改，请务必确保如下事项已完成:',
  'accountSettings.set.closed': '餐厅已打烊',
  'accountSettings.set.clockedOut': '员工已全部打卡下班',
  'accountSettings.set.next': '下一步',
  'accountSettings.set.cancel': '取消',
  'accountSettings.set.confirm': '确定',
  'accountSettings.set.know': '知道了',
  'accountSettings.set.step1': '步骤 1/2 餐厅已打烊',
  'accountSettings.set.step2': '步骤 2/2 修改报告截止时间',
  'accountSettings.set.step2.des': '确定后将自动结束营业，下一营业日将以设置的时间开始生效',
  'accountSettings.set.history.title': '修改记录',
  'accountSettings.set.history.originalDate': '修改前时间',
  'accountSettings.set.history.modifiedDate': '修改后时间',
  'accountSettings.set.history.modifiedBy': '操作人',
  'accountSettings.set.history.actionTime': '操作时间',
  'accountSettings.set.history.empty': '暂无历史记录',
};
